module.exports = __webpack_public_path__ + "static/media/PressureWave_ES.05e31275.pdf";